import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const addSociety = createAsyncThunk("addSociety", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.post(`${API_KEY}/api/society/add`, data, {
      headers: { Authorization: `Barear ${token}`},
      "Content-Type": "application/json",
    });

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  addSocietyData: null,
  isError: false,
  errorMessage: "",
};
const addSocietySlice = createSlice({
  name: "addSociety",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addSociety.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addSociety.fulfilled, (state, action) => {
      state.isLoading = false;
      state.addSocietyData = action.payload;
    });
    builder.addCase(addSociety.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default addSocietySlice.reducer;